/**
 * SafeAvatar — img avatar avec fallback role-based.
 *
 * Comportement :
 * 1. Si `src` est renseigné → affiche la photo de l'utilisateur.
 * 2. Sinon → affiche l'avatar par défaut correspondant au rôle :
 *    - "pro" ou "artisan"          → /brand/avatar-pro.png (navy + orange, texte PRO)
 *    - "particulier" ou "client"   → /brand/avatar-particulier.png (orange + navy, texte PARTICULIER)
 *    - autre / non spécifié        → avatar PRO par défaut (neutre)
 * 3. Si l'image src renvoie une erreur (404, réseau) → bascule automatiquement sur le fallback rôle.
 *
 * Utilisation :
 *   <SafeAvatar src={user.avatar} role={user.role} name={user.name} className="w-16 h-16 rounded-2xl" />
 */
export function defaultAvatarUrl(role) {
  const r = (role || "").toLowerCase();
  if (r === "particulier" || r === "client") return "/brand/avatar-particulier.png";
  return "/brand/avatar-pro.png"; // pro / artisan / défaut
}

export default function SafeAvatar({ src, role, name, className, alt, ...rest }) {
  const fallback = defaultAvatarUrl(role);
  return (
    <img
      src={src || fallback}
      alt={alt || name || "avatar"}
      onError={(e) => {
        if (e.currentTarget.src !== new URL(fallback, window.location.origin).href) {
          e.currentTarget.src = fallback;
        }
      }}
      className={className}
      {...rest}
    />
  );
}
